import { render, staticRenderFns } from "./AddToDesignGalleryModal.vue?vue&type=template&id=19961778&scoped=true"
import script from "./AddToDesignGalleryModal.vue?vue&type=script&lang=js"
export * from "./AddToDesignGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./AddToDesignGalleryModal.vue?vue&type=style&index=0&id=19961778&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19961778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19961778')) {
      api.createRecord('19961778', component.options)
    } else {
      api.reload('19961778', component.options)
    }
    module.hot.accept("./AddToDesignGalleryModal.vue?vue&type=template&id=19961778&scoped=true", function () {
      api.rerender('19961778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/design-gallery/AddToDesignGalleryModal.vue"
export default component.exports